import Location from "./locationType2";
import withLocation from "../withLocation";

export default withLocation(Location);
